import {useMutation} from '@tanstack/react-query';
import {postAcceptWellBornProgram} from '../../services/postAcceptWellBornProgram';

export function useAcceptWellBornProgramMutation() {
	return useMutation({
		mutationFn: postAcceptWellBornProgram,
	});
}
